<template>
  <li>
    <router-link
      :to="path"
      class="flex items-center px-4 py-2.5 mx-2 text-[13px] transition-all duration-200 group relative"
      :class="{ 
        'bg-[#6366f1] text-white font-medium rounded-xl shadow-md shadow-indigo-500/20': active,
        'text-gray-500 font-medium hover:text-gray-900 hover:bg-gray-50 rounded-xl': !active
      }"
    >
      <el-icon 
        class="text-[18px] flex-shrink-0 transition-transform group-hover:scale-110" 
        :class="active ? 'text-white' : 'text-gray-400'"
      >
        <component :is="icon" />
      </el-icon>
      <transition name="fade">
        <span v-if="!collapsed" class="ml-3 font-bold tracking-wide truncate">{{ title }}</span>
      </transition>
      <!-- 即将上线标签 -->
      <span 
        v-if="!collapsed && future" 
        class="ml-auto text-[9px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap"
        :class="active ? 'bg-white/20 text-white' : 'bg-orange-100 text-orange-500'"
      >
        即将上线
      </span>
      <!-- 折叠态 tooltip -->
      <div v-if="collapsed" class="sidebar-tooltip">
        {{ title }}
        <div class="sidebar-tooltip-arrow"></div>
      </div>
    </router-link>
  </li>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps<{
  title: string
  path: string
  icon: Component
  future?: boolean
  collapsed: boolean
}>()

const route = useRoute()
const active = computed(() => route.path === props.path)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.sidebar-tooltip {
  position: fixed;
  left: 5rem;
  margin-left: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: #111827;
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.5rem;
  opacity: 0;
  visibility: hidden;
  transition-property: all;
  transition-duration: 300ms;
  white-space: nowrap;
  z-index: 50;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.group:hover .sidebar-tooltip {
  opacity: 1;
  visibility: visible;
}
.sidebar-tooltip-arrow {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-0.25rem, -50%);
  border: 4px solid transparent;
  border-right-color: #111827;
}
</style>
